import { useDispatch } from 'react-redux'
import { DRAWER_TYPES, strings } from '@constants'
import { toggleDrawer } from '@data/state/action/root'
import { AddressSelector, DrawerBodyWrapper } from '@base'
import { useEffect, useState } from 'react'
import { getUserAddressesApi } from '@data'
import { showLoader } from '@data/state/action'

const UpdateDispatchAddress = ({ user, onlyView, shipping_address, updateAddress, addNewAddress }) => {
	const globalDispatch = useDispatch()
	const [addresses, setAddresses] = useState()
	useEffect(() => {
		globalDispatch(showLoader(true))
		getUserAddressesApi(user?.user_id)
			.then((res) => {
				if (res.length > 0) setAddresses(res)
			})
			.catch((e) => console.log(e))
			.finally(() => {
				globalDispatch(showLoader(false))
			})
	}, [user])

	const addNewAddressHandler = () => {
		globalDispatch(
			toggleDrawer(true, DRAWER_TYPES.ADD_NEW_ADDRESS, {
				addToNewEnquiry: true,
				updateNewEnquiryCallback: _addNewAddressHandler,
				label: strings('add_new_address'),
			})
		)
	}

	const _addNewAddressHandler = (data) => {
		addNewAddress(data?.shipping_address)
	}
	const updateAddressInEnquiry = (value) => {
		updateAddress(value)
	}

	return (
		<DrawerBodyWrapper>
			<AddressSelector
				onlyView={onlyView}
				savedAddresses={addresses}
				selectedAddress={shipping_address}
				onChange={updateAddressInEnquiry}
				addNewAddressHandler={addNewAddressHandler}
			/>
		</DrawerBodyWrapper>
	)
}

export default UpdateDispatchAddress
